export const HOME_PHONE_UNLIMITED = {
  TITLE: "Home Phone Unlimited",
  ADD_HOME_PHONE_UNLIMITED: "Add Home Phone Unlimited",
  CONFIRMATION:
    "Do you want to continue with this service?(We will remove the charge from your monthly bill?)",
  ALREADY_SUBSCRIBED: "You are already subscribed to this service.",
};
export const F_SECURE_SUB_TITLE = "Protect Your Identity and Data";
export const NEW_FIBER_DISCOUNT_MESSAGE = `(For the remaining months of your 12-month promotional period)`;
export const PLAN_DETAILS = "Plan Details";
export const BROADBAND_FACTS = {
  TITLE: "Broadband Facts",
  SEE_MORE_DETAILS: "See more details",
  FIXED_BROADBAND_CUSTOMER_DISCLOSURE: "Fixed Broadband Customer Disclosure",
};
export const DIRECTORY_LISTING_INFORMATION = {
  TITLE: "Directory Listing Information",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  STREET_ADDRESS: "Street Address",
  VOICEMAIL: "Voicemail",
  CITY: "City",
  STATE: "State",
  ZIP: "Zip",
};
export const TAX_TOOLTIP_TITLE =
    "We estimate the tax based on your service address, Estimated monthly tax includes the tax for the product and your add-on";
export const BILL_CART = {
  TITLE: "Your New Monthly Bill",
  ESTIMATED_MONTHLY_TAX: "Estimated Monthly Tax",
  DUE_MONTHLY_PLUS_TAX: "Due Monthly + Tax",
  TOTAL_DUE_TODAY: "Total Due Today",
  INSTALLATION_ONE_TIME_CHARGE: "Installation (One time charge)",
  ESTIMATED_MONTHLY_CHARGE: "Estimated Monthly Charge",
  CURRENT_MONTHLY_CHARGE: "Your Current Monthly Charge",
  ESTIMATED_TAX: "Estimated Tax",
  INCLUDES_TAX_FOR_PRODUCT_AND_ADDON: "Estimated monthly tax includes the tax for the product and your add-on",
  SEE_ESTIMATED_TAX_TOOLTIP: "We estimate the tax based on your service address, Estimated monthly tax includes the tax for the product and your add-on",
}